import * as angular from "angular";
import {IController} from "angular";

export class resourceAllocationAgentAssignmentQueryTableCtrl implements IController {

  infiniteScroll: any;
  onAssign: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationAgentAssignmentQueryTable', {
    bindings: {
      infiniteScroll: '<',
      onAssign: '&'
    },
    template: require('./resource-allocation-agent-assignment-query-table.html').default,
    controller: resourceAllocationAgentAssignmentQueryTableCtrl
  });
